"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Nick Howland, unknown (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=10083%3A664))
 * @lastsynced 2026-10-29T13:49:45.157Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const CheckOutlineSolid = createSVGIcon(
  <path
    d="M12 .357a11.645 11.645 0 0 1 8.233 19.876 11.645 11.645 0 0 1-16.466 0 11.645 11.645 0 0 1 0-16.466A11.64 11.64 0 0 1 12 .357m4.962 7.363a.5.5 0 0 0-.704.068l-6.218 7.527a.22.22 0 0 1-.168.078.215.215 0 0 1-.166-.083L7.752 12.8a.5.5 0 0 0-.789.613l1.953 2.511.09.103a1.216 1.216 0 0 0 1.804-.074l6.219-7.529a.5.5 0 0 0-.067-.704"
    fillRule="evenodd"
    clipRule="evenodd"
    fill="currentColor"
  />,
  "CheckOutlineSolid",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
